<h2 mat-dialog-title class="text-lg font-bold mb-1">
  {{ data.type.code == DocumentTypeEnum.COTIZACION ? "Editar cotización" : "Editar pedido" }}
</h2>
<mat-dialog-content class="modal-content">
  <form #updateForm="ngForm">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <!-- Columna Izquierda -->
      <div class="space-y-4">
        <!-- Condición de expedición -->
        <mat-form-field class="w-full">
          <mat-label>Condición de expedición</mat-label>
          <mat-select [formControl]="expeditionConditionControl" name="expeditionConditionId"
            [required]="expeditionConditionRequired" [disabled]="expeditionConditionDisabled">
            <mat-option *ngFor="let expeditionCondition of expeditionConditionList" [value]="expeditionCondition._id"
              class="text-content">
              {{ expeditionCondition.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="expeditionConditionControl.hasError('required')">
            Este campo es obligatorio.
          </mat-error>
        </mat-form-field>

        <!-- Fecha de entrega -->
        <mat-form-field class="w-full">
          <mat-label>Fecha de entrega</mat-label>
          <input matInput [matDatepicker]="deliveryDatePicker" [formControl]="deliveryDateToUpdate">
          <mat-datepicker-toggle matSuffix [for]="deliveryDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #deliveryDatePicker></mat-datepicker>
        </mat-form-field>
      </div>

      <!-- Columna Derecha -->
      <div class="space-y-4">

        <!-- Orden de compra -->
        <mat-form-field class="w-full">
          <mat-label>Orden de compra</mat-label>
          <input matInput [formControl]="purchaseOrderToUpdate" name="purchaseOrder">
        </mat-form-field>

        <!-- Fecha de carga -->
        <mat-form-field class="w-full">
          <mat-label>Fecha de carga</mat-label>
          <input matInput [matDatepicker]="loadDatePicker" [formControl]="loadDateToUpdate">
          <mat-datepicker-toggle matSuffix [for]="loadDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #loadDatePicker></mat-datepicker>
        </mat-form-field>



      </div>
    </div>
    <!-- Dirección -->
    <mat-form-field class="w-full">
      <mat-label>Dirección</mat-label>
      <mat-select [formControl]="addressControl" name="addressId" [required]="addressRequired"
        [disabled]="addressDisabled">
        <mat-option *ngFor="let address of addressList" [value]="address._id" class="text-content">
          {{address?.externalKeys ? address?.externalKeys.code + ' - ' : ''}}{{ address.address }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="addressControl.hasError('required')">
        Este campo es obligatorio.
      </mat-error>
    </mat-form-field>
    <!-- Observaciones -->
    <mat-form-field class="w-full">
      <mat-label>Observaciones</mat-label>
      <textarea placeholder="Observaciones" aria-label="Observaciones" matInput [formControl]="noteControl"
        name="noteId" [required]="noteRequired" [disabled]="noteDisabled" rows="3"></textarea>
      <mat-error *ngIf="noteControl.hasError('required')">
        Este campo es obligatorio.
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button mat-raised-button color="primary" (click)="openConfirmationDialog()" [disabled]="!updateForm.valid"
    class="justify-end">
    Actualizar
  </button>
</mat-dialog-actions>

<ng-template #orderConfirmationDialog let-data>
  <div class="flex items-start space-x-2 mb-4">
    <div class="flex items-center">
      <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-yellow-500 ml-4 mt-6"
        style="font-size: 32px"></mat-icon>
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        Confirmar actualización
      </h2>
      <mat-dialog-content class="modal-content mt-0">
        <p>¿Está seguro que desea actualizar?</p>
      </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-end">
    <button mat-button mat-dialog-close class="align-left">Cancelar</button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true">
      Aceptar
    </button>
  </mat-dialog-actions>
</ng-template>